import { render, staticRenderFns } from "./ItemCardComponent.vue?vue&type=template&id=a0d3605a"
import script from "./ItemCardComponent.vue?vue&type=script&lang=js"
export * from "./ItemCardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports